import { useEffect } from "react";
import Banner from "../../components/banner/Banner";
import { Link } from "react-router-dom";

function LegalInfoPage(props: { isConnect: boolean }) {

  useEffect(() => {
    // Si l'URL contient un hash, faites défiler jusqu'à l'élément correspondant
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []); // Exécution une seule fois au montage de la page

  return (
    <>
      <Banner isConnect={props.isConnect} showBtnHome={true} />

      <h1 className="text-4xl font-bold p-4 text-greenCustom">Informations légales</h1>

      <div className="gap-4">

        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Description des abonnements</h2>

          <div>
            L'application donne accès à deux types de forfait:

            <p><strong>Un forfait BASIC</strong>, dès ton inscription, d'un mois renouvelable automatiquement.</p>
            <p><strong>Un forfait PREMIUM</strong> d'un mois renouvelable automatiquement, pour 2,99 euros/mois, bientôt diponible.</p>
            <p>Dans les deux cas: L’abonnement mensuel prend effet à la date de souscription et reste valide jusqu’à la veille de la date anniversaire du mois suivant à 23h59. Par exemple, un abonnement souscrit le 8 mai sera actif jusqu’au 7 juin à 23h59.</p>
            <ul className="list-disc">
              <li><strong>Conditions de paiement de l'abonnement premium:</strong> Paiement de l'abonnement par carte bancaire, renouvelé automatiquement tous les mois à la date du 1er paiement (c'est à dire à la date de la fin de l'abonnement).</li>
              <p>Le traitement des paiements est assuré par notre prestataire Stripe. Aucune donnée bancaire n’est conservée sur nos serveurs.</p>
              <p> Tu trouveras un récap des fonctionnalités <a href="/about" className=" font-bold text-orangeCustom hover:underline">ici</a>.</p>
              <li> <strong>Conditions de résiliation de l'abonnement:</strong>
                <p> - ABONNEMENT BASIC</p>
                <p>La résiliation de l'abonnement sera effective à la date de fin de l'abonnement en cours en cas de demande de suppression de compte.</p>
                <p> - ABONNEMENT PREMIUM</p>
                <p>La résiliation de l'abonnement sera effective à la date de fin de l'abonnement en cours.
                  En cas d'absence de paiement ou de demande de changement d'abonnement, tu passeras automatiquement sur un abonnement BASIC après la date de fin du dernier abonnement qui a déjà été payé.
                  En cas de suppression de compte, l'abonnement et le compte seront supprimé après la date de fin du dernier abonnement qui a déjà été payé.</p></li>
              <li><strong>Droit de rétractation:</strong></li>
              <p>Aucun remboursement, même partiel, ne sera effectué pour une période d’abonnement déjà entamée, sauf en cas d’obligation légale. Conformément à l’article L221-28 du Code de la consommation, l’utilisateur renonce à son droit de rétractation en accédant immédiatement au service au moment de la souscription. Une fois le paiement de ton abonnement mensuel effectué, tu peux demander le changement d'abonnement à tout moment et repasser à un abonnement BASIC dès la fin de ta dernière période d'abonnement payante.</p>
            </ul>
            <p> Tu trouveras plus de détails dans la page CGU/V <a href="/terms-services" className=" font-bold text-orangeCustom hover:underline">ici</a>.</p>
          </div>
        </section>

        {/* Part personal data protection */}
        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Protection des données personnelles</h2>
          <p>Pour en savoir plus sur la collecte, l'utilisation et la protection de tes données personnelles, consulte notre <a href="/privacy-policy" className=" font-bold text-orangeCustom hover:underline">Politique de Confidentialité</a>.</p>
        </section>

        <section className="text-start p-4" id="section-cible2">
          <h2 className="text-3xl font-bold text-start pb-2">Propriété intellectuelle</h2>

          <p>
            Les contenus présents sur l’application Cemade (textes, images, logos, vidéos, code source, bases de données, éléments graphiques, icônes, etc.) sont la propriété exclusive de Cemade et sont protégés par les lois en vigueur relatives à la propriété intellectuelle.
            Toute reproduction, représentation, adaptation, diffusion ou utilisation, même partielle, de ces éléments sans autorisation écrite préalable est strictement interdite, sauf dans les cas prévus par l’article L122-5 du Code de la Propriété Intellectuelle (courtes citations, usage privé, etc.).
            Toute violation est considérée comme une contrefaçon et peut entraîner des poursuites civiles et pénales. </p>
        </section>

        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Conditions génerales</h2>
          <p>Les Conditions Générales d'Utilisation et les Conditions Générales de Vente applicables à l'utilisation de l'application sont disponibles à tout moment via le lien suivant :</p>
          <p><a href="/terms-services" className=" font-bold text-orangeCustom hover:underline">Conditions d'utilisation et de vente (CGU/V)</a></p>
        </section>

        <section className="text-start p-4" id="section-cible3">
          <h2 className="text-3xl font-bold text-start pb-2">Responsabilités</h2>

          <p><strong>Interactions entre utilisateurs</strong></p>
          <ul className="list-disc">
            <li className="pb-2">Cemade est un outil de mise en relation. Elle n’intervient pas dans les échanges ou les accords entre voyageurs et résidents.</li>
            <li className="pb-2">Cemade décline toute responsabilité en cas de litige, de conflit ou d’incident survenu lors d’une interaction (physique ou virtuelle). {/*Toutefois, en ce qui concerne les abonnements payants, nous ne pouvons garantir un nombre minimum d'utilisateurs actifs ou une participation spécifique sur l'application. Le nombre d’utilisateurs présents ou actifs sur l'application peut varier en fonction de nombreux facteurs indépendants de notre volonté, tels que l’engagement des utilisateurs ou les fluctuations de la base d’utilisateurs. En conséquence, <strong>Cemade</strong> ne saurait être tenu responsable de toute déception ou préjudice résultant de la variation du nombre d’utilisateurs dans le cadre de l'abonnement payant.*/}</li>
            <li className="pb-2">Les utilisateurs sont seuls responsables des engagements pris et de leur comportement sur la plateforme, comme en dehors.</li>
            <li className="pb-2">Il est vivement recommandé de consulter de nouveau la charte de bonnes conduites, dont la lecture a été exigée lors de l’inscription, avant toute interaction ou rencontre avec un autre utilisateur.</li>
          </ul>
          <p><strong>Fonctionnement du service</strong></p>
          <ul className="list-disc">
            <li className="pb-2">Nos fonctionnalités sont fournies « en l’état ». Cemade ne garantit pas un accès permanent ni l’absence de bugs ou d'interruptions.</li>
            <li className="pb-2">Le fonctionnement de l'application peut être interrompu temporairement (maintenance, mises à jour, sécurité) sans compensation. Dans la mesure du possible, <strong>Cemade</strong> s'engage à t'informer avant toute maintenance ou mise à jour planifiée qui pourrait avoir une incidence sur ton utilisation de l'application. Si nécessaire, certaines fonctionnalités peuvent également être désactivées de façon permanente pour motifs de sécurité ou autres.</li>
          </ul>
          <p><strong>Contenus publiés par les utilisateurs</strong></p>
          <ul className="list-disc">
            <li className="pb-2">Cemade ne vérifie pas systématiquement l'identité des utilisateurs lors de l’inscription.</li>
            <li className="pb-2">L’utilisateur est seul responsable du contenu qu’il publie, qu’il s’agisse de présentations, de descriptions ou de commentaires.</li>
            <li className="pb-2">Cemade ne garantit pas l’exactitude ou la légalité des informations fournies par les utilisateurs.</li>
            <li className="pb-2">Les badges sont attribués à titre informatif et ne constituent pas une garantie contractuelle.</li>
            <li className="pb-2">En cas de contenu illicite ou problématique, signale-le via notre système de contact.</li>

          </ul>
          <p><strong>Limitation de responsabilité</strong></p>
          <ul className="list-disc">
            <li className="pb-2">Cemade n’est pas responsable de la variation du nombre d’utilisateurs actifs, y compris dans le cadre d’un abonnement PREMIUM.</li>
            <li className="pb-2">Aucun résultat ou interaction spécifique n’est garanti par la plateforme.</li>
            <li className="pb-2">Cemade ne peut être tenu responsable de dommages indirects, immatériels ou imprévisibles (perte d’opportunité, préjudice moral, perte de données, etc.).</li>
          </ul>

          <p><strong>Sécurité et données personnelles</strong></p>
          <ul className="list-disc">
            <li className="pb-2">Cemade met en œuvre des mesures de sécurité techniques et organisationnelles pour protéger tes données.</li>
            <li className="pb-2">Cemade limite la collecte de données au strict nécessaire.</li>
          </ul>

        </section>


        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Loi applicable</h2>
          <p>Les présentes mentions légales sont soumises au droit français.</p>
        </section>

        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Contact</h2>
          <p>Pour toute question relative à ces mentions légales, tu peux nous contacter en <strong><Link to="/contact">cliquant ici.</Link></strong></p>
        </section>

        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2"> Hébergeur de l'application</h2>

          <ul>
            <li><strong>Nom de l'hébergeur</strong> : OVH SAS</li>
            <li><strong>Adresse de l'hébergeur</strong> : 2 rue Kellermann, 59100 Roubaix, France</li>
            <li><strong>Contact de l'hébergeur</strong> : <a href="mailto:support@ovh.com">support@ovh.com</a></li>
          </ul>
        </section>


        <section className="text-start p-4">
          <h2 className="text-3xl font-bold text-start pb-2">Copyright</h2>

          <p>© 2025 Cemade. Tous droits réservés.</p>
        </section>

      </div >
    </>
  )
}
export default LegalInfoPage;